(() => {
  'use strict';
  const SECTION_SELECTOR = '[data-section-type]';

  class RecentlyViewed extends HTMLElement {
    constructor() {
      super();
      this.loaded = false;
      this.observer = null;
    }

    connectedCallback() {
      this.section = this.closest(SECTION_SELECTOR);
      this.howManyToShow = parseInt(this.dataset.limit, 10) || 3;
      this.target = this.dataset.target;
      this.wrapperId = this.dataset.wrapperId || this.id;

      if (!('IntersectionObserver' in window)) {
        this.load();
        return;
      }

      this.observer = new IntersectionObserver((entries, observer) => {
        if (!entries[0] || !entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.load();
      }, { rootMargin: '0px 0px 600px 0px' });

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    load() {
      if (this.loaded) return;
      this.loaded = true;
      Shopify.Products.showRecentlyViewed({
        howManyToShow: this.howManyToShow,
        wrapperId: this.wrapperId,
        section: this.section,
        target: this.target,
        onComplete: () => {
          this.dispatchEvent(new CustomEvent('theme:recently-viewed:loaded', { bubbles: false }));
        }
      });
    }
  }

  if (!customElements.get('recently-viewed')) customElements.define('recently-viewed', RecentlyViewed);
})();
